import { render, staticRenderFns } from "./FilialeDetails.vue?vue&type=template&id=8223770a&scoped=true"
import script from "./FilialeDetails.vue?vue&type=script&lang=js"
export * from "./FilialeDetails.vue?vue&type=script&lang=js"
import style0 from "./FilialeDetails.vue?vue&type=style&index=0&id=8223770a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8223770a",
  null
  
)

export default component.exports